<template>
    <v-card>
        <v-card-title>
            <template v-if="isAdmin">
                <v-btn
                    dark
                    color="primary"
                    class="mb-2"
                    :to="{ name: 'CadastrarColaborador' }"
                >
                    <v-icon>add</v-icon> Cadastrar Colaborador
                </v-btn>
                <v-divider
                    class="mx-3 hidden-md-and-down mt-0"
                    inset
                    vertical
                ></v-divider>
            </template>
            <v-text-field
                v-model="search.query"
                @click:clear="clearQuery"
                @keyup.enter="loadData()"
                type="text"
                prepend-icon="search"
                label="Pesquisar"
                clear-icon="cancel"
                clearable
                hide-details
                solo
            ></v-text-field>

            <v-btn
                class="ml-2"
                color="primary"
                :disabled="!search.ready"
                @click="loadData()"
            >Buscar</v-btn>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
            <data-table :setup.sync="dataTable" @delete-item="deleteItem"></data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import API from '@/api'
import DataTable from '@/components/DataTable'

export default {
    name: 'list-users',
    components: {
        DataTable
    },
    data: () => {
        return {
            isAdmin: false,
            search: {
                ready: true,
                query: ''
            },
            dataTable: {
                loading: true,
                itemName: 'Colaborador',
                headers: [
                    { text: 'Nome', value: 'name', width: '85%' },
                    {
                        text: 'Tipo de Acesso',
                        value: 'mainAccount',
                        width: '15%',
                        align: 'center',
                        sortable: false
                    }
                ],
                items: [],
                totalItems: 0,
                detailTo: '',
                editTo: 'EditarColaborador',
                pagination: {
                    multiSort: true,
                    mustSort: false,
                    page: 1,
                    itemsPerPage: 500,
                    groupBy: [],
                    groupDesc: [],
                    sortBy: ['name'],
                    sortDesc: [false],
                    sortFormated: [
                        { value: 'name', descending: false }
                    ]
                },
                footerProps: {
                    itemsPerPageOptions: [500, 250, 100, 50, 25, 10]
                }
            }
        }
    },
    watch: {
        'dataTable.pagination.sortBy': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.dataTable.sortingTimeout !== undefined) clearTimeout(this.dataTable.sortingTimeout)
                    this.dataTable.sortingTimeout = setTimeout(() => {
                        this.loadData()
                    }, 1000)
                }
            },
            deep: true
        },
        'dataTable.pagination.page': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.itemsPerPage': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.adminOnly()
        this.loadData()
    },
    methods: {
        adminOnly () {
            if (this.$helpers.checkIsMainAccount()) {
                this.isAdmin = true
                this.dataTable.headers[0].width = '70%'
                this.dataTable.headers.push(
                    {
                        text: 'Ações',
                        value: 'actions',
                        align: 'center',
                        sortable: false,
                        edit: true,
                        delete: true,
                        width: '15%'
                    }
                )
            }
        },
        getSortFormated (sortArray) {
            const sortFormated = sortArray.map((sortObj) => {
                return `${(sortObj.descending) ? '-' : ''}${sortObj.value}`
            })
            return sortFormated.join()
        },
        clearQuery () {
            this.search.query = ''
            this.loadData()
        },
        async loadData () {
            await this.$helpers.sleep(0)
            this.dataTable.loading = true
            this.search.ready = false
            const endpoint = API.EndPoints.getUserCompany
            const where = {
                client: {
                    __type: 'Pointer',
                    className: 'Client',
                    objectId: this.$helpers.getUserCompany().client.objectId
                }
            }

            const params = {
                limit: this.dataTable.pagination.itemsPerPage,
                skip: (this.dataTable.pagination.page - 1) * this.dataTable.pagination.itemsPerPage,
                count: true,
                order: this.getSortFormated(this.dataTable.pagination.sortFormated),
                where: JSON.stringify(where),
                include: ['user']
            }

            await new API(endpoint, params).request()
                .then(response => {
                    this.dataTable.items = response.body.results.map((result) => {
                        result.user.userCompanyId = result.objectId
                        result.user.mainAccount = (result.permissions.isMainAccount) ? 'Administrador' : 'Não administrador'
                        return result.user
                    })
                    this.dataTable.totalItems = response.body.count
                    this.search.ready = true
                    this.dataTable.loading = false
                }, (e) => {
                    this.$helpers.requestError(e)
                })
        },
        async deleteItem (item) {
            let endpoint = API.EndPoints.deleteUserCompany
            endpoint.id = item.userCompanyId
            let msg = ''
            await new API(endpoint).request()
                .then(() => { msg = 'Usuário removida com sucesso!' })
                .catch(() => { msg = 'Ocorreu um erro!' })
            if (msg !== '') alert(msg)
            this.loadData()
        }
    }
}
</script>
